import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderDate(props: ICasRenderCellProps) {
  return formatDate(getCasTableCellValue(props), DateFormat.MDY);
}
